import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import LabOffering from "@/pages/LabOffering";

export const Route = createFileRoute("/es/servicios/lab-services/ensayos-de-disolventes-residuales-gc")({
  head: () => buildRouteHead("/es/servicios/lab-services/ensayos-de-disolventes-residuales-gc"),
  component: LabOffering,
});

